<template>
  <div id="content-wrapper">
    <div class="container-fluid pb-0">
      <div class="top-mobile-search">
        <div class="row">
          <div class="col-md-12">
            <form class="mobile-search">
              <div class="input-group">
                <input type="text" placeholder="Search for..." class="form-control" />
                <div class="input-group-append">
                  <button type="button" class="btn btn-dark">
                    <i class="fas fa-search"></i>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="video-block section-padding">
        <div class="row">
          <div class="col-md-12">
            <div class="main-title">
              <div class="btn-group float-right right-action">
                <router-link class="right-action-link text-gray" to="/category/action">See More</router-link>
              </div>
              <h6>Action</h6>
            </div>
          </div>
          <div
            class="col-xl-3 col-sm-6 mb-3"
            v-for="(video, i) in  action_videoinfos"
            v-bind:key="i"
          >
            <videoinfocard
              :title_text="video.title"
              :video_id="video.id"
              :image_src="video.cover"
              :duration="video.duration"
              :views="video.updated_at"
              :time_post="video.created_at"
              :category="video.category"
            ></videoinfocard>
          </div>
        </div>
      </div>
      <hr class="mt-0" />

      <div class="video-block section-padding">
        <div class="row">
          <div class="col-md-12">
            <div class="main-title">
              <div class="btn-group float-right right-action">
                <!-- <a class="right-action-link text-gray">See More</a> -->
                <router-link class="right-action-link text-gray" to="/category/comed">See More</router-link>
              </div>
              <h6>Comedy</h6>
            </div>
          </div>
          <div class="col-xl-3 col-sm-6 mb-3" v-for="(video, i) in comed_videoinfos" v-bind:key="i">
            <videoinfocard
              :title_text="video.title"
              :video_id="video.id"
              :image_src="video.cover"
              :duration="video.duration"
              :views="video.updated_at"
              :time_post="video.created_at"
              :category="video.category"
            ></videoinfocard>
          </div>
        </div>
      </div>
      <hr class="mt-0" />

      <div class="video-block section-padding">
        <div class="row">
          <div class="col-md-12">
            <div class="main-title">
              <div class="btn-group float-right right-action">
                <!-- <a class="right-action-link text-gray">See More</a> -->
                <router-link class="right-action-link text-gray" to="/category/anima">See More</router-link>
              </div>
              <h6>Animation</h6>
            </div>
          </div>
          <div class="col-xl-3 col-sm-6 mb-3" v-for="(video, i) in anima_videoinfos" v-bind:key="i">
            <videoinfocard
              :title_text="video.title"
              :video_id="video.id"
              :image_src="video.cover"
              :duration="video.duration"
              :views="video.updated_at"
              :time_post="video.created_at"
              :category="video.category"
            ></videoinfocard>
          </div>
        </div>
      </div>
      <hr class="mt-0" />

      <div class="video-block section-padding">
        <div class="row">
          <div class="col-md-12">
            <div class="main-title">
              <div class="btn-group float-right right-action">
                <!-- <a class="right-action-link text-gray">See More</a> -->
                <router-link class="right-action-link text-gray" to="/category/drama">See More</router-link>
              </div>
              <h6>Drama</h6>
            </div>
          </div>
          <div class="col-xl-3 col-sm-6 mb-3" v-for="(video, i) in drama_videoinfos" v-bind:key="i">
            <videoinfocard
              :title_text="video.title"
              :video_id="video.id"
              :image_src="video.cover"
              :duration="video.duration"
              :views="video.updated_at"
              :time_post="video.created_at"
              :category="video.category"
            ></videoinfocard>
          </div>
        </div>
      </div>
      <hr class="mt-0" />

      <div class="video-block section-padding">
        <div class="row">
          <div class="col-md-12">
            <div class="main-title">
              <div class="btn-group float-right right-action">
                <!-- <a class="right-action-link text-gray">See More</a> -->
                <router-link class="right-action-link text-gray" to="/category/romanc">See More</router-link>
              </div>
              <h6>Romance</h6>
            </div>
          </div>
          <div
            class="col-xl-3 col-sm-6 mb-3"
            v-for="(video, i) in romanc_videoinfos"
            v-bind:key="i"
          >
            <videoinfocard
              :title_text="video.title"
              :video_id="video.id"
              :image_src="video.cover"
              :duration="video.duration"
              :views="video.updated_at"
              :time_post="video.created_at"
              :category="video.category"
            ></videoinfocard>
          </div>
        </div>
      </div>
      <hr class="mt-0" />

      <div class="video-block section-padding">
        <div class="row">
          <div class="col-md-12">
            <div class="main-title">
              <div class="btn-group float-right right-action">
                <!-- <a class="right-action-link text-gray">See More</a> -->
                <router-link class="right-action-link text-gray" to="/category/horror">See More</router-link>
              </div>
              <h6>Horror</h6>
            </div>
          </div>
          <div
            class="col-xl-3 col-sm-6 mb-3"
            v-for="(video, i) in horror_videoinfos"
            v-bind:key="i"
          >
            <videoinfocard
              :title_text="video.title"
              :video_id="video.id"
              :image_src="video.cover"
              :duration="video.duration"
              :views="video.updated_at"
              :time_post="video.created_at"
              :category="video.category"
            ></videoinfocard>
          </div>
        </div>
      </div>
      <hr class="mt-0" />

      <div class="video-block section-padding">
        <div class="row">
          <div class="col-md-12">
            <div class="main-title">
              <div class="btn-group float-right right-action">
                <!-- <a class="right-action-link text-gray">See More</a> -->
                <router-link class="right-action-link text-gray" to="/category/sci-fi">See More</router-link>
              </div>
              <h6>Sci-fi</h6>
            </div>
          </div>
          <div class="col-xl-3 col-sm-6 mb-3" v-for="(video, i) in scifi_videoinfos" v-bind:key="i">
            <videoinfocard
              :title_text="video.title"
              :video_id="video.id"
              :image_src="video.cover"
              :duration="video.duration"
              :views="video.updated_at"
              :time_post="video.created_at"
              :category="video.category"
            ></videoinfocard>
          </div>
        </div>
      </div>
      <hr class="mt-0" />

      <div class="video-block section-padding">
        <div class="row">
          <div class="col-md-12">
            <div class="main-title">
              <div class="btn-group float-right right-action">
                <!-- <a class="right-action-link text-gray">See More</a> -->
                <router-link class="right-action-link text-gray" to="/category/others">See More</router-link>
              </div>
              <h6>Others</h6>
            </div>
          </div>
          <div
            class="col-xl-3 col-sm-6 mb-3"
            v-for="(video, i) in others_videoinfos"
            v-bind:key="i"
          >
            <videoinfocard
              :title_text="video.title"
              :video_id="video.id"
              :image_src="video.cover"
              :duration="video.duration"
              :views="video.updated_at"
              :time_post="video.created_at"
              :category="video.category"
            ></videoinfocard>
          </div>
        </div>
      </div>
      <hr class="mt-0" />
    </div>
  </div>
</template>


<script>
import videoinfocard from "../components/videoinfocard.vue";
import BasicAPIs from "../api/apis";
export default {
  name: "PgAllCategories",
  components: {
    videoinfocard
  },
  props: {},
  data: function() {
    return {
      comed_videoinfos: [],
      anima_videoinfos: [],
      drama_videoinfos: [],
      romanc_videoinfos: [],
      horror_videoinfos: [],
      action_videoinfos: [],
      others_videoinfos: [],
      scifi_videoinfos: []
    };
  },
  computed: {},
  created() {},
  mounted() {
    let vm = this;
    let num_lm = 4;
    let c_list = this.$store.state.categories;

    for (var i = 0; i < c_list.length; i++) {
      let c = c_list[i];
      BasicAPIs.getByCategory(c).then(res => {
        console.log(c);
        if (c === "Action") {
          vm.action_videoinfos = res.data.data.Items.slice(0, num_lm);
        } else if (c === "Others") {
          vm.others_videoinfos = res.data.data.Items.slice(0, num_lm);
        } else if (c === "Sci-fi") {
          vm.scifi_videoinfos = res.data.data.Items.slice(0, num_lm);
        } else if (c === "Horror") {
          vm.horror_videoinfos = res.data.data.Items.slice(0, num_lm);
        } else if (c === "Romance") {
          vm.romanc_videoinfos = res.data.data.Items.slice(0, num_lm);
        } else if (c === "Drama") {
          vm.drama_videoinfos = res.data.data.Items.slice(0, num_lm);
        } else if (c === "Animation") {
          vm.anima_videoinfos = res.data.data.Items.slice(0, num_lm);
        } else if (c === "Comedy") {
          vm.comed_videoinfos = res.data.data.Items.slice(0, num_lm);
        }

        // console.log();
      });
    }
  }
};
</script>


<style  lang='scss'>
</style>